import config from 'baseConfig/pg/v2/orders';

import {
  CHECKBOX,
  ORDER_TYPE_ITEMS_IMPORTS,
} from 'baseConfig/pg/v2/constants';

export default {
  DEFAULT: {
    TABLE_COLUMNS: [
      {
        key: 'addedOnTime',
        displayName: 'Created At',
        width: 0.12,
        tooltip: {
          message: 'Order Created On',
        },
      },
      ...config.DEFAULT.TABLE_COLUMNS,
    ],
    FILTER_ITEMS: {
      ...config.DEFAULT.FILTER_ITEMS,
      orderType: {
        displayText: 'Order Type',
        type: CHECKBOX,
        items: ORDER_TYPE_ITEMS_IMPORTS,
      },
      // orderSource: {
      //   displayText: 'Integration Type',
      //   type: CHECKBOX,
      //   items: ORDER_SOURCE_ITEMS_IMPORT,
      // },
    },
    SEARCH_ITEMS: [...config.DEFAULT.SEARCH_ITEMS],
  },
};
